export default "__VITE_ASSET__JoOGv_ph__"